import { StudentAnalyticsPage } from './student-analytics-page'

export default StudentAnalyticsPage
